export const NewContactModal: string = 'NewContactModal';
